import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router';
import AdminNavbarItem from '../components/AdminNavbarItem';

const mapStateToProps = null;

const mapDispatchToProps = null;

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const {
    router, params, location, routes, ...restOfOwnProps
  } = ownProps;

  const { id } = params;

  return {
    ...restOfOwnProps,
    text: 'Settings',
    icon: 'settings',
    componentClass: Link,
    to: `/admin/settings/pages${id ? `?page=${id}` : ''}`,
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
  )(AdminNavbarItem),
);
